import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import {agentDeveloperUtils} from 'wobi-web-common';
import {Tooltip} from '@mui/material';
import {FormattedMessage} from 'react-intl';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    display: 'inline-flex',
    backgroundColor: '#e8e8e8',
    borderRadius: 9999,
    padding: 2,
  },
  tab: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    minWidth: 0,
    padding: '5px 1.5rem',
    fontSize: 14,
    fontWeight: 500,
    border: 'none',
    borderRadius: 9999,
    backgroundColor: 'transparent',
    color: '#555555',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    '&:focus': {
      outline: 'none',
    },
  },
  active: {
    backgroundColor: agentDeveloperUtils.getPrimaryColor(440),
    color: '#3b3b3b',
  },

  riderSubheaderItem: {
    fontSize: theme.typography.pxToRem(12),
    alignSelf: 'center',
    padding: '0 10px',
  },
  tooltip: {
    border: 'none',
    borderRadius: 9999,
    backgroundColor: 'inherit',
    fontSize: theme.typography.fontSize,
    color: theme.palette.secondary.main,
    display: 'inline-block',
    transition: '0.3s all',

    // borderBottom: '2px solid transparent',
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
    '& img': {
      height: '20px',
    },
  },
}));

const DynamicTabs = ({
  tabs,
  defaultActive,
  onChange,
  sortButtonsTitle,
  show = true,
}) => {
  const { classes } = useStyles();
  const [active, setActive] = useState(defaultActive || tabs[0]?.id);

  const handleClick = (id) => {
    setActive(id);
    if (onChange) {
      onChange(id);
    }
  };
  if (!show) {
    return null;
  }
  return (
    <span
      style={{
        paddingBottom: '5px',
      }}
    >
      {sortButtonsTitle ? (
        <span className={classes.riderSubheaderItem}>{sortButtonsTitle}</span>
      ) : null}
      <div className={classes.wrapper}>
        <div style={{display: 'flex',
          flex: 1}}>
          {tabs.map((tab) => (
            <button
              type='button'
              key={tab.id}
              onClick={() => handleClick(tab.id)}
              className={`${classes.tab} ${
                active === tab.id ? classes.active : ''
              }`}
            >
              {tab.label}
              {tab.toolTipConfig && (
                <Tooltip
                  className={`${classes.tooltip}  ${
                    active === tab.id ? classes.active : ''
                  }`}
                  placement={
                    tab.toolTipConfig.placement ?
                      tab.toolTipConfig.placement :
                      'left'
                  }
                  title={
                    <FormattedMessage
                      id={`${tab.toolTipConfig.description}`}
                    />
                  } ד
                >
                  <span style={{display: 'flex'}}>
                    <img
                      src={tab.toolTipConfig.icon}
                      alt=''
                      aria-hidden='true'
                    />
                  </span>
                </Tooltip>
              )}
            </button>
          ))}
        </div>
      </div>
    </span>
  );
};

DynamicTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      toolTipConfig: PropTypes.shape({
        description: PropTypes.string,
        icon: PropTypes.string,
      }),
    }),
  ).isRequired,
  defaultActive: PropTypes.string,
  onChange: PropTypes.func,
  sortButtonsTitle: PropTypes.string,
  show: PropTypes.bool,
};

export default DynamicTabs;
